import { api } from './api';
import { Case, Invoice, Document, Payment, Credit } from '../types';

// Portal-specific types that exclude internal notes
export interface PortalPayment extends Omit<Payment, 'notes'> {}
export interface PortalCredit extends Omit<Credit, 'internalNotes'> {}

export interface PortalInvoiceWithPayments {
  invoice: Invoice;
  payments: PortalPayment[];
  credits: PortalCredit[];
}

export const portalApi = {
  getCases: async (): Promise<{ cases: Case[]; count: number }> => {
    return api.get<{ cases: Case[]; count: number }>('/portal/cases');
  },

  getInvoices: async (): Promise<{ invoices: Invoice[]; count: number }> => {
    return api.get<{ invoices: Invoice[]; count: number }>('/portal/invoices');
  },

  getInvoice: async (id: string): Promise<Invoice> => {
    return api.get<Invoice>(`/portal/invoices/${id}`);
  },

  getInvoiceWithPayments: async (id: string): Promise<PortalInvoiceWithPayments> => {
    return api.get<PortalInvoiceWithPayments>(`/portal/invoices/${id}?includePayments=true`);
  },

  getDocuments: async (caseId?: string): Promise<{ documents: Document[]; count: number }> => {
    const url = caseId ? `/portal/documents?caseId=${caseId}` : '/portal/documents';
    return api.get<{ documents: Document[]; count: number }>(url);
  },

  getDocumentDownloadUrl: async (id: string): Promise<{ downloadUrl: string; fileName: string }> => {
    return api.get<{ downloadUrl: string; fileName: string }>(`/portal/documents/${id}?action=download`);
  },
};
